import React, { MutableRefObject } from "react";
import { SliderButtonRef } from "@swiggy-private/payment-types";

export interface SliderButtonContextValue {
    onPostSliderSuccessCallback: () => void;
    sliderButtonRef: MutableRefObject<SliderButtonRef | null>;
}

export const SliderButtonContext = React.createContext<SliderButtonContextValue>({
    onPostSliderSuccessCallback: () => void 0,
    sliderButtonRef: {
        current: null,
    },
});
